export const TAGS = 'tags'

export const API_PATH = '/tags'
